import type { TemplateNodesDict } from 'src/exShared/types/types'
import {
  countTableSectionNodes,
  isTableSectionNode,
  TABLE_SECTION_MAX_NODE_COUNT,
} from 'src/features/templateEdit/section/table/model/tableSection'

export type TableSectionSoftLimitViolation = {
  /** 違反した表セクション名（未設定時は「（名称未設定）」） */
  sectionName: string
  /** 現在のノード数 */
  nodeCount: number
}

/**
 * すべての表セクションについて、ノード数上限の超過を静的に検証する。
 * 「上限超過（> limit）」でエラー。境界値（ちょうど上限）は許容する。
 *
 * @returns 上限を超過した違反の一覧（超過がなければ空配列）
 */
export const collectTableSectionSoftLimitViolations = (
  templateNodes: TemplateNodesDict,
): TableSectionSoftLimitViolation[] =>
  Object.values(templateNodes)
    .filter(isTableSectionNode)
    .map(node => ({
      sectionName: node.section?.name?.trim() || '（名称未設定）',
      nodeCount: countTableSectionNodes(node, templateNodes),
    }))
    .filter(({ nodeCount }) => nodeCount > TABLE_SECTION_MAX_NODE_COUNT)
